import React from 'react';
import PropTypes from 'prop-types';

import { PROJECT_TYPES, PROJECTS_CONFIG } from '@/appConstants';
import WaitingScreen from '@/components/PaymentPage/WaitingScreen';
import Icon from '@/components/Shared/Icon';

import {
  Container,
  Footer,
  Header,
  HeaderContentWrapper,
  LogoWrapper,
  Main,
  PhoneWrapper,
} from './style';

const year = new Date().getFullYear();
const layoutData = {
  [PROJECT_TYPES.minfin]: {
    logo: 'minfinLogo',
    phone: PROJECTS_CONFIG.minfin.phone,
    footerText: `© 2008–${year} Товариство з обмеженою відповідальністю «МiнфiнМедiа» <br>Адреса: вул.М.Грінченка, 4В, бізнес-центр «Horizon Park», Київ, Україна. Графік роботи: Пн-Пт 9:00–18:00`,
  },
  [PROJECT_TYPES.multi]: {
    logo: '',
    phone: PROJECTS_CONFIG.multi.phone,
    footerText: '',
  },
  [PROJECT_TYPES.finance]: {
    logo: 'financeLogo',
    phone: PROJECTS_CONFIG.finance.phone,
    footerText: `© 2000–${year} Товариство з обмеженою відповідальністю «Файненс.юа»<br>Адреса: вул. Миколи Грінченка, 4В, 55Г, Київ, Україна.<br>Графік роботи: Пн-Пт 9:00–18:00`,
  },
};

function Layout({ resource, isShowWaitingScreen, children }) {
  return (
    <>
      {isShowWaitingScreen && <WaitingScreen resource={resource} />}
      <Container>
        <Header $isHidden={resource === PROJECT_TYPES.multi}>
          <HeaderContentWrapper $isVisible={resource === PROJECT_TYPES.minfin}>
            <LogoWrapper>
              <Icon name={layoutData[resource].logo} width={110} />
            </LogoWrapper>
            <PhoneWrapper>
              <Icon name="phone" width={12} />
              {layoutData[resource].phone}
            </PhoneWrapper>
          </HeaderContentWrapper>
        </Header>
        <Main>{children}</Main>
        <Footer
          $isHidden={resource === PROJECT_TYPES.multi}
          dangerouslySetInnerHTML={{ __html: layoutData[resource].footerText }}
        />
      </Container>
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  isShowWaitingScreen: PropTypes.bool.isRequired,
  resource: PropTypes.oneOf([
    PROJECT_TYPES.minfin,
    PROJECT_TYPES.finance,
    PROJECT_TYPES.multi,
  ]).isRequired,
};

export default Layout;
